import Building from "@/views/building";
import { getCurrentInstance } from "vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const store = getCurrentInstance()?.proxy?.$store;

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    redirect: {
      name: "home-root",
    },
  },
  {
    path: "/app/outer",
    name: "app",
    component: () => import("../views/outer-frame/index"),
    redirect: { name: "home-root" },
    children: [
      {
        path: "",
        name: "app-root",
        redirect: { name: "home-root" },
      },
      {
        path: "home",
        name: "home-section",
        children: [
          {
            path: "",
            name: "home-root",
            meta: { title: "渲沅山庄-首页" },
            component: () => import("../views/home/index"),
          },
        ],
      },
      {
        path: "online-tools",
        name: "online-tools",
        children: [
          {
            path: "",
            name: "online-tools-root",
            meta: { title: "渲沅山庄-在线工具" },
            component: () => import("../views/online-tools/index"),
          },
          {
            path: "encoding",
            name: "online-tools-encoding",
            redirect: { name: "online-tools-base64" },
            children: [
              { path: "base64", name: "online-tools-base64", component: () => import("../views/online-tools/encoding/base64") },
              { path: "url-encode", name: "online-tools-url-encode", component: () => import("../views/online-tools/encoding/url-encode") },
              { path: "unicode", name: "online-tools-unicode", component: () => import("../views/online-tools/encoding/unicode") },
            ],
          },
          {
            path: "formatting",
            name: "online-tools-formatting",
            redirect: { name: "online-tools-json-format" },
            children: [
              { path: "json", name: "online-tools-json-format", component: () => import("../views/online-tools/formatting/json-format") },
              { path: "xml", name: "online-tools-xml-format", component: () => import("../views/online-tools/formatting/xml-format") },
              { path: "html", name: "online-tools-html-format", component: () => import("../views/online-tools/formatting/html-format") },
              { path: "properties-yaml", name: "online-tools-properties-yaml", component: () => import("../views/online-tools/formatting/properties-yaml") },
              { path: "sql", name: "online-tools-sql-format", meta: { title: "渲沅山庄-SQL格式化" }, component: () => import("../views/online-tools/formatting/sql-format") },
              { path: "json-csv", name: "online-tools-json-csv", meta: { title: "渲沅山庄-JSON/CSV转换" }, component: () => import("../views/online-tools/formatting/json-csv") },
            ],
          },
          {
            path: "cryptography",
            name: "online-tools-cryptography",
            redirect: { name: "online-tools-encryption-aes" },
            children: [
              { path: "md5", name: "online-tools-md5", component: () => import("../views/online-tools/cryptography/md5") },
              { path: "aes", name: "online-tools-encryption-aes", component: () => import("../views/online-tools/cryptography/aes") },
              { path: "des", name: "online-tools-encryption-des", component: () => import("../views/online-tools/cryptography/des") },
              { path: "rsa", name: "online-tools-encryption-rsa", component: () => import("../views/online-tools/cryptography/rsa") },
              { path: "sha", name: "online-tools-encryption-sha", component: () => import("../views/online-tools/cryptography/sha") },
              { path: "crc32", name: "online-tools-crc32", meta: { title: "渲沅山庄-CRC32校验" }, component: () => import("../views/online-tools/cryptography/crc32") },
            ],
          },
          {
            path: "generation",
            name: "online-tools-generation",
            redirect: { name: "online-tools-uuid" },
            children: [
              { path: "uuid", name: "online-tools-uuid", component: () => import("../views/online-tools/generation/uuid") },
              { path: "random", name: "online-tools-random", component: () => import("../views/online-tools/generation/random-string") },
              { path: "timestamp", name: "online-tools-timestamp", component: () => import("../views/online-tools/generation/timestamp") },
              { path: "radix", name: "online-tools-radix", component: () => import("../views/online-tools/generation/radix-conversion") },
            ],
          },
          {
            path: "development",
            name: "online-tools-development",
            redirect: { name: "online-tools-regex-tester" },
            children: [
              { path: "regex", name: "online-tools-regex-tester", component: () => import("../views/online-tools/development/regex-tester") },
              { path: "word-count", name: "online-tools-word-count", component: () => import("../views/online-tools/development/word-count") },
              { path: "cron", name: "online-tools-cron-expression", component: () => import("../views/online-tools/development/cron-expression") },
              { path: "jwt", name: "online-tools-jwt-decoder", component: () => import("../views/online-tools/development/jwt-decoder") },
              { path: "http-status", name: "online-tools-http-status", component: () => import("../views/online-tools/development/http-status") },
              { path: "mime", name: "online-tools-mime", component: () => import("../views/online-tools/development/mime") },
              { path: "case-converter", name: "online-tools-case-converter", component: () => import("../views/online-tools/development/case-converter") },
              { path: "text-dedup-sort", name: "online-tools-text-dedup-sort", meta: { title: "渲沅山庄-文本去重排序" }, component: () => import("../views/online-tools/development/text-dedup-sort") },
              { path: "text-diff", name: "online-tools-text-diff", meta: { title: "渲沅山庄-文本对比" }, component: () => import("../views/online-tools/development/text-diff") },
              { path: "csv-table", name: "online-tools-csv-table", meta: { title: "渲沅山庄-CSV表格" }, component: () => import("../views/online-tools/development/csv-table") },
            ],
          },
          {
            path: "visual",
            name: "online-tools-visual",
            redirect: { name: "online-tools-color-convert" },
            children: [
              { path: "color", name: "online-tools-color-convert", component: () => import("../views/online-tools/visual/color-convert") },
              { path: "qrcode", name: "online-tools-qrcode-generator", component: () => import("../views/online-tools/visual/qrcode-generator") },
              { path: "ascii", name: "online-tools-ascii-table", component: () => import("../views/online-tools/visual/ascii-table") },
            ],
          },
          // {
          //   path: "city",
          //   name: "online-tools-city",
          //   meta: {
          //     title: "渲沅山庄-行政区划",
          //   },
          //   component: () =>
          //     import("../views/online-tools/administrative-division"),
          // },
        ],
      },
      {
        path: "dev-course",
        name: "dev-course",
        redirect: { name: "dev-course-home" },
        children: [
          {
            path: "",
            name: "dev-course-home",
            meta: { title: "渲沅山庄-开发教程" },
            component: () => import("../views/dev-course/index"),
          },
          {
            path: "track/:trackSlug",
            name: "dev-course-track",
            meta: { title: "渲沅山庄-教程体系" },
            component: () => import("../views/dev-course/track-detail"),
          },
          {
            path: "learn/:trackSlug/:courseSlug/:articleSlug?",
            name: "dev-course-learn",
            meta: { title: "渲沅山庄-教程学习" },
            component: () => import("../views/dev-course/learn"),
          },
          {
            path: ":trackSlug",
            redirect: (to) => ({ name: "dev-course-track", params: { trackSlug: to.params.trackSlug } }),
          },
        ],
      },
      {
        path: "toolbox",
        name: "toolbox-overview",
        meta: { title: "渲沅山庄-工具箱" },
        component: () => import("../views/toolbox/index"),
      },
      {
        path: "local-settings",
        name: "local-settings-overview",
        meta: { title: "渲沅山庄-本地设置" },
        component: () => import("../views/local-settings/index"),
      },
      {
        path: "404",
        name: "404",
        component: Building,
      },
    ],
  },
  // {
  //   path: '/app/uuus',
  //   name: 'uuus',
  //   component: () => import('../views/inner-frame/index.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: "/:pathMatch(.*)",
    redirect: {
      name: "404",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to, from, next) => {
  document.title = to?.meta?.title || store?.state?.common?.title || "渲沅山庄-欢迎光临";
  next();
});

export default router;
